// İrsaliyeler listesi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.waybills';

export const waybillsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'İrsaliyeler nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'İrsaliye, malın müşteriye gönderildiğini gösteren sevk belgesidir. Bu sayfada irsaliyelerinizi listeler, yazdırır ve faturaya bağlarsınız. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    stats: t(`${G}.regions.stats`, 'Özet kartları'),
    filters: t(`${G}.regions.filters`, 'Arama ve sıralama'),
    toolbar: t(`${G}.regions.toolbar`, 'Yeni İrsaliye ve ⋮'),
    table: t(`${G}.regions.table`, 'İrsaliye listesi'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. İrsaliye neyi etkiler?'),
      text: t(`${G}.s1.text`, 'İrsaliye kaydetmek stok miktarını ve cari bakiyeyi değiştirmez; yalnız sevk belgesi oluşturur. Cari hareket, irsaliyeden oluşturduğunuz fatura kaydedilince oluşur.'),
    },
    {
      region: 'stats',
      title: t(`${G}.s2.title`, '2. Özet kartlarını okuyun'),
      text: t(`${G}.s2.text`, 'Bugün Kesilen ve Bu Ay kartları adet ile tutarı, Toplam Kalem Sayısı irsaliyelerdeki kalem sayısını gösterir; bu üç kart ekrandaki sayfada listelenen irsaliyelere göre hesaplanır. Toplam İrsaliye ise tüm irsaliyelerinizin sayısıdır.'),
    },
    {
      region: 'toolbar',
      title: t(`${G}.s3.title`, '3. Yeni irsaliye oluşturun'),
      text: t(`${G}.s3.text`, '"Yeni İrsaliye" irsaliye formunu açar: cariyi, tarihi ve ürünleri girip kaydedin. Formdaki "Fiyatları PDF/Yazdırmada Göster" düğmesiyle çıktıda fiyatların görünüp görünmeyeceğini seçersiniz.'),
      tips: [
        t(`${G}.s3.tip1`, 'Listedeki Fiyat sütunu bu seçimi gösterir: Görünür veya Gizli.'),
        t(`${G}.s3.tip2`, 'Siparişler sayfasındaki "İrsaliye Oluştur" ile de sipariş bilgileri dolu bir irsaliye açabilirsiniz; irsaliye o siparişe bağlanır.'),
        t(`${G}.s3.tip3`, '⋮ düğmesindeki "Excel İndir" listeyi Excel dosyasına aktarır.'),
      ],
    },
    {
      region: 'filters',
      title: t(`${G}.s4.title`, '4. İrsaliyeyi bulun'),
      text: t(`${G}.s4.text`, 'Arama kutusuna aradığınız irsaliyeyi yazın (ör. irsaliye no). Filtre simgesi tarih sıralamasını açar: Yeniden Eskiye veya Eskiden Yeniye.'),
    },
    {
      region: 'table',
      title: t(`${G}.s5.title`, '5. Görüntüleyin, yazdırın, düzenleyin'),
      text: t(`${G}.s5.text`, 'Satırın ⋮ menüsünde Görüntüle, Düzenle, PDF İndir ve Sil bulunur. "PDF İndir" irsaliyeyi çıktı penceresinde açar; buradan PDF alabilir veya yazdırabilirsiniz. Silme işlemi geri alınamaz.'),
    },
    {
      region: 'table',
      title: t(`${G}.s6.title`, '6. Faturaya bağlayın'),
      text: t(`${G}.s6.text`, 'Faturası kesilmemiş bir irsaliyede ⋮ menüsündeki "Fatura Oluştur" satış faturası formunu irsaliye bilgileriyle dolu açar. Faturayı kaydettiğinizde irsaliyenin durumu "Faturalandı" olur ve fatura irsaliyeye bağlanır.'),
      tips: [
        t(`${G}.s6.tip1`, 'Faturası olan irsaliyede menüde "Fatura Göster" çıkar.'),
        t(`${G}.s6.tip2`, 'Durum: Aktif (henüz faturalanmadı) veya Faturalandı. Etiketin üzerine gelince bağlı sipariş veya fatura numarası görünür.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s7.title`, '7. Sayfalar arasında gezin'),
      text: t(`${G}.s7.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına satır sayısını seçin. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
